import axios from 'axios';

import { handleError } from '@/shared/services/api';

export default {
  baseUrl(subsidyProgramId) {
    return `${window.api_url}/member/subsidy_programs/${subsidyProgramId}/seat_types`;
  },

  index(subsidyProgramId, params) {
    return axios.get(this.baseUrl(subsidyProgramId), { params }).catch(handleError);
  },

  create(seatType) {
    return axios
      .post(this.baseUrl(seatType.subsidy_program_id), { seat_type: seatType })
      .catch(handleError);
  },

  destroy(seatType) {
    return axios
      .delete(`${this.baseUrl(seatType.subsidy_program_id)}/${seatType.id}`)
      .catch(handleError);
  },

  update(seatType) {
    return axios
      .patch(`${this.baseUrl(seatType.subsidy_program_id)}/${seatType.id}`, { seat_type: seatType })
      .catch(handleError);
  },
};
